<script>
import headNav from "../components/headNav.vue";
import {register,getEmailCode,editPassword} from "../api/api";
import router from "../router";

export default {
  name: "login",
  components:{headNav},
  data(){
    return{
      nickname:'',
      email:'',
      password:'',
      emailcode:'',
      content: 'sending',
      totalTime: 60,
      canClick: false
    }
  },
  methods:{
    go(name){
      router.push(
        {
          name
        }
      )
    },
    submit(){

      let reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
      if(!reg.test(this.email) || this.email.trim() == ''){
        this.mes('Email is empty or incorrect','warning')
        return
      }
      if(this.password.trim() == ''){
        this.mes('password cannot be empty','warning')
        return
      }
      if(this.emailcode.trim() == ''){
        this.mes('Email Verification code cannot be empty','warning')
        return
      }
      editPassword({
        email:this.email,
        password:this.password,
        code:this.emailcode
      }).then( res => {
        console.log(res,"打印res")
        if(res.data.status == 200){
          this.mes(res.data.message,'success')
          setTimeout(() => {
            this.go('login')
          },1000)
        }else {
          this.mes(res.data.message,'error')
        }
      })
    },
    mes(message,type){
      this.$message({
        message,
        type
      });
    },
    sendMsg() {
      if (this.canClick) return
      let reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
      if(!reg.test(this.email) || this.email.trim() == ''){
        this.mes('Email is empty or incorrect','warning')
        return
      }
      this.canClick = true
      this.content =  `Resend in ${this.totalTime} seconds`
      getEmailCode({
        email:this.email,
      }).then( res => {
        console.log(res,"打印res")
        if(res.data.status == 200){
          this.mes(res.data.message,'success')
        }else{
          this.mes(res.data.message,'error')
          return
        }
        let clock = window.setInterval(() => {
          this.totalTime--
          this.content = `Resend in ${this.totalTime} seconds`
          if (this.totalTime < 0) {
            window.clearInterval(clock)
            this.content = 'Resend'
            this.totalTime = 60
            this.canClick = false
          }
        }, 1000)
      })

    }
  }
}
</script>

<template>
  <div>
<!--    <head-nav></head-nav>-->
    <section class="section">
      <div class="container">
        <div class="row justify-content-center align-items-center">
          <!--          <div class="col-lg-6">-->
          <!--            <div class="section-title text-center">-->
          <!--              <p class="text-primary text-uppercase fw-bold mb-3">Contact With us</p>-->
          <!--              <h1>login</h1>-->
          <!--&lt;!&ndash;              <p>Lorem ipsum dolor sit, consectetur adipiscing . egestas cursus pellentesque dignissim dui, congue etiam</p>&ndash;&gt;-->
          <!--            </div>-->
          <!--          </div>-->
          <div class="col-lg-6">
            <div class="shadow rounded p-5 bg-white">
              <div class="row">
                <div class="col-12 mb-4">
                  <h4>Change password</h4>
                </div>
                <div class="col-lg-12">
                  <div class="contact-form">
                    <div class="form-group mb-4 pb-2">
                      <label for="exampleFormControlInput1" class="form-label">Email</label>
                      <input v-model="email" type="email" class="form-control shadow-none">
                    </div>
                    <div class="form-group mb-4 pb-2">
                      <label for="exampleFormControlInput1" class="form-label">password</label>
                      <input v-model="password" type="password" class="form-control shadow-none" >
                    </div>
                    <div class="form-group mb-4 pb-2">
                      <label for="exampleFormControlInput1" class="form-label">Email Verification code</label>
                      <input v-model="emailcode" type="number" class="form-control shadow-none" >
                      <!--                      <span><button style="float: right" class="btn-primary" @click="submit()">Register</button></span>-->
                      <span style="display: flex;justify-content: space-between">
                        <div></div>
                        <div><el-button @click="sendMsg" size="mini" type="success" :disabled="canClick">{{ content }}</el-button></div>
                      </span>
                    </div>
                    <button style="margin-top: 20px" class="btn btn-primary w-100" @click="submit()">Register</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped>
@import "../../css/style.css";
.register:hover{
  color:#2080E4;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/view/forgotPassword.vue